import Vue from "vue";
import Vuex from "vuex";
import options from "@/options";

import { gqlClient } from "../apollo/apollo-options";
import root from "./root";
import login from "./login";
import changePassword from "./changePassword";
import forgetPassword from "./forgetPassword";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    gql: gqlClient
  },
  modules: {
    ...options.modules,
    root,
    login,
    changePassword,
    forgetPassword
  },
  mutations: {},
  actions: {}
});
